module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames3-6c1bc8c70c7f4d07a7a4de562699e365.webp";